import { getBlobRequestWithAuth } from "../api";

export const getSessionAsset = async (sessionId: string, filename: string): Promise<Blob> => {
  const response = await getBlobRequestWithAuth(
    `/api/v1/chat/getSessionAsset?session_id=${sessionId}&filename=${filename}`
  );
  return response.data;
};

export const downloadAsset = async (sessionId: string, filename: string): Promise<void> => {
  try {
    const blob = await getSessionAsset(sessionId, filename);
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  } catch (error) {
    console.error('Error downloading asset:', error);
    throw error;
  }
};

export const getAssetContentAsText = async (sessionId: string, filename: string): Promise<string> => {
  const blob = await getSessionAsset(sessionId, filename);
  return await blob.text();
};

export const getAssetType = (filename: string): 'html' | 'csv' | 'excel' | 'unknown' => {
  const extension = filename.toLowerCase().split('.').pop();
  switch (extension) {
    case 'html':
    case 'htm':
      return 'html';
    case 'csv':
      return 'csv';
    case 'xlsx':
    case 'xls':
      return 'excel';
    default:
      return 'unknown';
  }
};